export default __webpack_public_path__ + "static/wwf-logo-9b5fe75549034a431630c7bf40fdcce4.png";